import React from "react";
import {
  FileText,
  Users,
  Building2,
  Receipt,
  ArrowRight,
} from "lucide-react";

const Dashboard = () => {
  const modules = [
    {
      title: "RTI Management",
      description: "Create and manage RTI records",
      icon: <FileText size={20} />,
      link: "/rti-list",
      color: "bg-blue-50 text-blue-600",
    },
    {
      title: "Occupancy",
      description: "Manage occupancy charges",
      icon: <Building2 size={20} />,
      link: "/occupancy-list",
      color: "bg-emerald-50 text-emerald-600",
    },
    {
      title: "Developer Charges",
      description: "Track developer charge entries",
      icon: <Receipt size={20} />,
      link: "/developer-list",
      color: "bg-amber-50 text-amber-600",
    },
    {
      title: "Users",
      description: "Manage application users",
      icon: <Users size={20} />,
      link: "/user-list",
      color: "bg-purple-50 text-purple-600",
    },
  ];

  const quickActions = [
    {
      title: "Add RTI",
      link: "/rti-add",
    },
    {
      title: "Add Occupancy",
      link: "/occupancy-add",
    },
    {
      title: "Add Developer Charge",
      link: "/developer-add",
    },
    {
      title: "Add User",
      link: "/user-add",
    },
  ];

  return (
    <div className="min-h-full">
      <div className="max-w-7xl mx-auto space-y-6">

        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">

            <div>
              <p className="text-sm text-white font-medium mb-2">
                PrintPro Dashboard
              </p>

              <h1 className="text-2xl font-semibold text-white">
                Welcome Back
              </h1>

              <p className=" text-white mt-2 text-sm">
                Manage RTI records, occupancy modules,
                developer charges, and users from one place.
              </p>
            </div>

            
          </div>
        </div>

        {/* Modules */}
        <div>
          <div className="mb-4">
            <h2 className="text-lg font-semibold text-gray-800">
              Modules
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Access different sections of the system
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
            {modules.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="bg-white border border-gray-200 rounded-2xl p-5 hover:border-blue-200 hover:shadow-md transition-all"
              >
                <div
                  className={`w-11 h-11 rounded-xl flex items-center justify-center ${item.color}`}
                >
                  {item.icon}
                </div>

                <h3 className="text-base font-semibold text-gray-800 mt-4">
                  {item.title}
                </h3>

                <p className="text-sm text-gray-500 mt-1 leading-relaxed">
                  {item.description}
                </p>

                <div className="flex items-center gap-2 mt-5 text-sm font-medium text-blue-600">
                  Open Module
                  <ArrowRight size={15} />
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
          <div className="mb-5">
            <h2 className="text-lg font-semibold text-gray-800">
              Quick Actions
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Frequently used actions
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {quickActions.map((action, index) => (
              <a
                key={index}
                href={action.link}
                className="border border-gray-200 hover:border-blue-200 hover:bg-blue-50 rounded-xl px-4 py-4 text-sm font-medium text-gray-700 transition text-center"
              >
                {action.title}
              </a>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;